export default __webpack_public_path__ + "static/media/LogoNew.e8992a6b.svg";